import React, { Fragment } from "react";
import UserEditButton from "./userEditButton";
// react-admin
import {
  Edit,
  TabbedForm,
  FormTab,
  TextInput,
  NumberInput,
  DateInput,
  BooleanInput,
  RadioButtonGroupInput,
  SelectInput,
  ReferenceInput,
  AutocompleteArrayInput,
  required,
  regex,
  ImageInput,
  Toolbar,
} from "react-admin";

import {
  Paper,
  //Typography,
  Grid,
  makeStyles,
} from "@material-ui/core";

// react-final-form
import { useForm } from "react-final-form";

//hooks
import { GetCertificates, FetchIndustries } from "./hooks";

const useStyle = makeStyles({
  header: {
    marginLeft: "3%",
    marginTop: "2%",
    margin: "auto",
  },

  avatar: {
    height: "10rem",
    width: "10rem",
  },
  row: {
    marginLeft: "3%",
  },
  mobileRow: {
    marginLeft: "3%",
    display: "flex",
  },
  countryCode: {
    minWidth: "0px",
    width: "10vh",
  },
  Mentorrow: {
    marginLeft: "1%",
  },
  paperMentor: {
    height: "63vh",
    width: "100%",
    overflowY: "scroll",
    overflowX: "hidden",
  },
  paperAddress: {
    height: "63vh",
    width: "100%",
    overflowY: "scroll",
    overflowX: "hidden",
  },
  paper: {
    height: "63vh",
  },

  fieldWidth10: { width: "10vw" },
  fieldWidth15: { width: "15vw" },
  fieldWidth20: { width: "20vw" },
  fieldWidth25: { width: "25vw" },
  fieldWidth30: { width: "30vw" },
  fieldWidth35: { width: "35vw" },
  hideIt: {
    display: "none",
  },
});

const processingFee = [
  regex(/^\b((100)|[1-9]?\d)\b$/, "Enter the digit between 1 to 100"),
  required(),
];

const CustomToolbar = (props) => (
  <Toolbar {...props}>
    <UserEditButton />
  </Toolbar>
);

const PreviewImage = ({ record }) => {
  return (
    <img
      style={{
        width: "10vh",
        height: "10vh",
        borderRadius: "50vh",
      }}
      src={record._url ? record._url : record.src}
      alt="logo"
    />
  );
};

const EmailForm = ({ formData, ...rest }) => {
  const classes = useStyle();
  const form = useForm();
  return (
    <Fragment>
      <TextInput
        source="email_"
        variant="standard"
        fullWidth="true"
        onChange={(v) => form.change("email", v.target.value)}
      />
      <TextInput source="email" className={classes.hideIt} />
    </Fragment>
  );
};

const EditMobileNo = (props) => {
  const validateMobileNoCreation = (value) => {
    console.log("value", value.toString().length);

    if (props.country === "61" && value.toString().length !== 9) {
      console.log("AUS");
      return "Invalid Mobile No";
    }

    // if (!ausRegex.test(value)) {
    //   return "Invalid Mobile No";
    // }

    if (props.country === "91" && value.toString().length !== 10) {
      console.log("IN");
      return "Invalid Mobile No";
    }

    // if (!indRegex.test(value)) {
    //   return "Invalid Mobile No";
    // }

    return undefined;
  };
  const validateMobileNo = [required(), validateMobileNoCreation];

  console.log("record", props);
  // console.log("country",country)
  return (
    <NumberInput
      source="mobileNo"
      variant="standard"
      validate={validateMobileNo}
    />
  );
};

const TabbedUserForm = (props) => {
  const isMentor = props.record.isMentor;
  const classes = useStyle();
  const certifcateList = GetCertificates();
  const industryCategories = FetchIndustries();
  const [country, setCountry] = React.useState("");

  const handleCountryChange = (e) => {
    setCountry(e.target.value);
  };

  return (
    <TabbedForm
      {...props}
      initialValues={{
        mobileNo: null,
      }}
      toolbar={<CustomToolbar />}
    >
      <FormTab label="Communication Details">
        <Paper elevation={0} className={classes.paper}>
          <Grid container direction="column" spacing={2}>
            <Grid item xs={12} className={classes.row}>
              <ImageInput
                source="profileImage"
                accept="image/*"
                labelSingle="Upload"
                key="ProfileImg"
              >
                <PreviewImage source="src" />
              </ImageInput>

              {/* <Avatar
                alt=""
                src={props.record.profileImage}
                className={classes.avatar}
              /> */}
              {/* {isImageSet ? (
                <Avatar
                  className={classes.avatar}
                  src={image}
                  source="profileImage"
                />
              ) : (
                <Avatar
                  alt=""
                  src={props.record.profileImage}
                  source="profileImage"
                  className={classes.avatar}
                />
              )} */}
              {/* <ImageComp props={props} />
              <br />
              <input
                accept="image/*"
                style={{
                  display: "none",
                }}
                onChange={handleChangeImage}
                id="upload-button-file"
                multiple
                type="file"
              />
              <label htmlFor="upload-button-file">
                <Button variant="contained" component="span">
                  Upload Image
                </Button>
              </label> */}
            </Grid>
            <Grid item xs={12} className={classes.mobileRow}>
              <Grid item xs={6}>
                <SelectInput
                  source="countryCode"
                  label="Code"
                  // variant="outlined"
                  onChange={handleCountryChange}
                  className={classes.countryCode}
                  choices={[
                    { id: "91", name: "IN (+91)" },
                    { id: "61", name: "AUS (+61)" },
                  ]}
                  validate={[required()]}
                />
              </Grid>
              <Grid item>
                <EditMobileNo {...props} country={country} />
              </Grid>
            </Grid>
            <Grid item xs={12} className={classes.row}>
              <EmailForm />
            </Grid>
            <Grid item xs={12} className={classes.row}>
              <BooleanInput label="User OptedIn" source="OptIn" />
            </Grid>
          </Grid>
        </Paper>
      </FormTab>
      <FormTab label="Personal Details">
        <Paper elevation={0} className={classes.paper}>
          <Grid
            container
            justify="flex-start"
            alignItems="flex-start"
            spacing={2}
          >
            <Grid item className={classes.row}>
              <TextInput source="name" variant="standard" />
            </Grid>
            <Grid item className={classes.row}>
              <DateInput source="dateOfBirth" variant="standard" />
            </Grid>
            <Grid item className={classes.row}>
              <RadioButtonGroupInput
                source="gender"
                optionValue="name"
                choices={[
                  { id: "m", name: "Male" },
                  { id: "f", name: "Female" },
                  { id: "o", name: "Choose Not to Specify" },
                ]}
              />
            </Grid>
          </Grid>
        </Paper>
      </FormTab>
      <FormTab label="Address">
        <Paper elevation={0} className={classes.paperAddress}>
          <Grid container direction="column" spacing={2}>
            <Grid item xs={12} className={classes.row}>
              <Grid
                container
                justify="flex-start"
                alignItems="flex-start"
                spacing={2}
              >
                <Grid item xs={6}>
                  <TextInput
                    source="addressLine1"
                    variant="standard"
                    fullWidth="true"
                    multiline
                  />
                </Grid>
              </Grid>
              <Grid
                container
                justify="flex-start"
                alignItems="flex-start"
                spacing={2}
              >
                <Grid item xs={6}>
                  <TextInput
                    source="addressLine2"
                    variant="standard"
                    fullWidth="true"
                    multiline
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} className={classes.row}>
              <Grid
                container
                justify="flex-start"
                alignItems="flex-start"
                spacing={2}
              >
                <Grid item>
                  <TextInput source="city" variant="standard" />
                </Grid>
                <Grid item>
                  <TextInput source="state" variant="standard" />
                </Grid>
                <Grid item>
                  <TextInput source="country" variant="standard" />
                </Grid>
                <Grid item>
                  <NumberInput source="pincode" variant="standard" />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </FormTab>
      {isMentor ? (
        <FormTab label="Mentor Details">
          <Paper elevation={0} className={classes.paperMentor}>
            <Grid
              container
              justify="flex-start"
              alignItems="flex-start"
              direction="column"
              spacing={2}
            >
              <Grid item className={classes.Mentorrow}>
                <TextInput
                  multiline
                  source="description"
                  variant="outlined"
                  className={classes.fieldWidth25}
                />
              </Grid>
              <Grid item className={classes.Mentorrow}>
                <SelectInput
                  source="industry"
                  label="Industry"
                  variant="outlined"
                  className={classes.field}
                  // style={{ marginLeft: 500, marginTop: -72 }}
                  optionValue="name"
                  choices={
                    industryCategories.loaded
                      ? industryCategories.data.map((ctgry) => {
                          return { id: ctgry.id, name: ctgry.Category };
                        })
                      : [{ id: "1", name: "Loading Categories ...." }]
                  }
                />
              </Grid>
              <Grid item className={classes.Mentorrow}>
                <ReferenceInput
                  label="Badge"
                  source="userBadge.id"
                  reference="UserBadge"
                >
                  <SelectInput optionText="badgeName" variant="outlined" />
                </ReferenceInput>
              </Grid>

              <Grid
                item
                style={{
                  marginLeft: "1%",
                  width: "20px",
                }}
              >
                <AutocompleteArrayInput
                  source="Certification"
                  label="Certification"
                  variant="standard"
                  choices={
                    certifcateList.loaded &&
                    certifcateList.data !== undefined &&
                    certifcateList.data !== null
                      ? certifcateList.data.map((r) => ({
                          id: r.id,
                          name: r.certificateName,
                        }))
                      : []
                  }
                  optionValue="name"
                />
              </Grid>
              <Grid
                item
                className={classes.Mentorrow}
                style={{ marginTop: 20 }}
              >
                <BooleanInput
                  source="profileVerified"
                  label="Verify Mentor Profile"
                />
              </Grid>
            </Grid>
          </Paper>
        </FormTab>
      ) : null}
      {isMentor ? (
        <FormTab label="Pricing Details">
          <Paper elevation={0} className={classes.paper}>
            <Grid
              container
              justify="flex-start"
              alignItems="flex-start"
              spacing={2}
            >
              <Grid item className={classes.row}>
                <TextInput
                  source="processingFee"
                  variant="outlined"
                  validate={processingFee}
                  className={classes.fieldWidth25}
                />
              </Grid>
              <Grid item className={classes.row}>
                <NumberInput
                  source="mentorFee"
                  variant="outlined"
                  validate={required()}
                  className={classes.fieldWidth25}
                />
              </Grid>
            </Grid>
          </Paper>
        </FormTab>
      ) : null}
    </TabbedForm>
  );
};

const UserEdit = (props) => (
  <Edit title="Update Details" {...props}>
    <TabbedUserForm />
  </Edit>
);

export default UserEdit;
